import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { DestinationMarketplaceValue } from '@/types/auction';
import { ToggleSwitch } from '@liveauctioneers/hammer-ui-core/toggleSwitch';
import { useCallback } from 'react';

type PartnerNetworkRowProps = Readonly<{
    code: DestinationMarketplaceValue;
    disabled: boolean;
    isToggled: boolean;
    label: string;
    onToggle: (code: DestinationMarketplaceValue, isEnabled: boolean) => Promise<void> | void;
}>;

export const PartnerNetworkRow = ({ code, disabled, isToggled, label, onToggle }: PartnerNetworkRowProps) => {
    const handleToggleChange = useCallback(
        (nextIsToggled?: boolean) => {
            void onToggle(code, nextIsToggled ?? false);
        },
        [code, onToggle]
    );

    return (
        <div className="flex items-center justify-between gap-sm p-md">
            <BodyPrimary className="min-w-0 flex-1">{label}</BodyPrimary>
            <ToggleSwitch
                aria-label={label}
                data-testid={`partner-network-toggle-${code}`}
                disabled={disabled}
                isToggled={isToggled}
                onToggleChange={handleToggleChange}
                small
            />
        </div>
    );
};

PartnerNetworkRow.displayName = 'PartnerNetworkRow';
